var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWrite48Filled = function SvgIconWrite48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 38.7H14.6a5.31 5.31 0 0 1-5.3-5.3V16.6c0-2.92 2.38-5.3 5.3-5.3H22v3.4h-7.4a1.9 1.9 0 0 0-1.9 1.9v16.8c0 1.05.85 1.9 1.9 1.9h16.8a1.9 1.9 0 0 0 1.9-1.9V26h3.4v7.4c0 2.92-2.38 5.3-5.3 5.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.28 14.38-3.66-3.66c-.47-.47-1.23-.47-1.7 0L19.36 23.28l-.97 4.92c-.16.84.57 1.57 1.41 1.41l4.92-.97 12.56-12.56c.47-.47.47-1.23 0-1.7Z",
    fill: "current"
  })));
};
export default SvgIconWrite48Filled;